<template>
  <bita-modal :id="modalId" :title="title" :modal-lg="true" :isLoading="isLoading" @close="onCloseModal">
    <div slot="body">
      <div class="row">
        <div class="col-6">
          نام و نام خانوادگی:
          {{ formItems.full_name ? formItems.full_name : "-" }}
        </div>
        <div class="col-6">
          زمان ثبت سفارش:
          {{
            formItems.created_at
              ? $getJalaliDateTime(formItems.created_at)
              : "-"
          }}
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          استان: {{ formItems.province ? formItems.province : "-" }}
        </div>
        <div class="col-6">
          شهر: {{ formItems.city ? formItems.city : "-" }}
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          ادرس: {{ formItems.address ? formItems.address : "-" }}
        </div>
        <div class="col-6">
          کدپستی: {{ formItems.postal_code ? formItems.postal_code : "-" }}
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          تلفن همراه: {{ formItems.mobile ? formItems.mobile : "-" }}
        </div>
        <div class="col-6">
          ایمیل: {{ formItems.email ? formItems.email : "-" }}
        </div>
      </div>
      <br />
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>کد</th>
            <th>نام</th>
            <th>تعداد</th>
            <th>قیمت واحد</th>
            <th>مبلغ کل</th>
            <th>مبلغ تخفیف</th>
            <th>مبلغ کل پس از تخفیف</th>
            <!-- <th>قیمت با تخفیف</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in formItems.items" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.product_price ? item.product_price.code : "-" }}</td>
            <td>
              {{ item.product.name }} <br />
              <small>{{ item.combination_text }}</small>
            </td>
            <td>{{ item.count }}</td>
            <td>{{ $thousandSeprator(item.price) }}</td>
            <td>{{ $thousandSeprator(item.price * item.count) }}</td>
            <td>{{ $thousandSeprator(item.payable_price - item.price) }}</td>
            <td>{{ $thousandSeprator(item.payable_price * item.count) }}</td>
          </tr>
          <tr>
            <td colspan="7" style="text-align: left">جمع کل</td>
            <td colspan="7">{{ $thousandSeprator(formItems.total) }}</td>
          </tr>
          <tr>
            <td colspan="7" style="text-align: left">هزینه حمل</td>
            <td colspan="7">
              {{ $thousandSeprator(formItems.shipping_price) }}
            </td>
          </tr>
          <tr>
            <td colspan="7" style="text-align: left">تخفیف حراجی</td>
            <td colspan="7">
              {{
                formItems.discount ? $thousandSeprator(formItems.discount) : "-"
              }}
            </td>
          </tr>
          <tr>
            <td colspan="7" style="text-align: left">سایر تخفیف ها</td>
            <td colspan="7">
              {{
                formItems.coupon_price
                  ? $thousandSeprator(formItems.coupon_price)
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td>
              پرداخت شده توسط کیف پول
            </td>
            <td colspan="2">{{ $thousandSeprator(formItems.wallet_payed) }}</td>
            <td>پرداخت آنلاین</td>
            <td colspan="2">{{ $thousandSeprator(formItems.online_payed) }}</td>
            <td>درگاه پرداخت</td>
            <td>{{ formItems.paymethod ? formItems.paymethod.title : "-" }}</td>
          </tr>
        </tbody>
      </table>
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-select name="status" label="وضعیت" ref="statusDropDown" rules="required"
              validation-container-class="col-lg-3 col-md-6 col-sm-6" input-class="form-control" :data-source="statuses"
              data-text-field="title" data-value-field="id" v-model="formItems.status" />
            <bita-input type="text" name="tonnage" label="پیگیری پست" rules=""
              validation-container-class="col-lg-3 col-md-6 col-sm-6" input-class="form-control"
              v-model="formItems.shipping_tracking_code" />
          </div>
          <div class="row">
            <bita-bootbutton v-if="formItems.paymethod && formItems.paymethod.method == 2" type="primary mr-2 ml-2"
              title="نمایش فیش" icon="fa fa-images" btn-width="200px" @click.native="showFullSizeImage" />
            <bita-bootbutton v-if="formItems.payment_status != 1" type="primary mr-2 ml-2" title="تایید پرداخت موفق"
              icon="fa fa-check" btn-width="200px" @click.native="paymentSuccessfully" />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton v-if="$acl.can('edit', 'orders')" type="primary" title="ذخیره" icon="fa fa-check"
        btn-width="150px" @click.native="handleSubmit()" />
      <bita-bootbutton class="mr-2" type="primary" title="چاپ لیبل پست" icon="fa fa-print" btn-width="150px"
        @click.native="labelPrint()" />
      <bita-bootbutton class="mr-2" type="primary" title="چاپ فاکتور" icon="fa fa-print" btn-width="150px"
        @click.native="printInvoice()" />
      <bita-bootbutton class="mr-2" type="danger" title="بستن" icon="fas fa-times" btn-width="150px"
        data-dismiss="modal" />
    </div>
  </bita-modal>
</template>
<script>
import { orderApi } from "@/api/apiManagement";

export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
    settings: {},
  },
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      formItems: {},
      dataForm: {},
      statuses: [],
    };
  },
  computed: {},
  mounted() {
    this.getStatuses();
  },
  methods: {
    setInitialData(_data) {
      this.isLoading = true;
      // this.formItems = _data;
      orderApi
        .findOrder(_data.id)
        .then((res) => {
          this.formItems = res.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getStatuses() {
      orderApi.getStatuses().then(({ data }) => (this.statuses = data));
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", {
            form_data: this.formItems,
            id: this.formItems.id,
          });
        }
      });
    },
    printInvoice() {
      let baseUrl = process.env.VUE_APP_API_BASEPOINT;
      window.open(`orders/${this.formItems.id}/print`, "_blank");
    },
    printTemplate() {
      if (this.formItems) {
        let cities = `${this.formItems.province}، ${this.formItems.city}`;
        let address = this.formItems.address ? this.formItems.address : "-";
        let fullName = this.formItems.full_name
          ? this.formItems.full_name
          : "-";
        let tel = this.formItems.mobile ? this.formItems.mobile : "-";
        let postalcode = this.formItems.postal_code
          ? this.formItems.postal_code
          : "-";
        let settings = this.settings;
        var template = "";
        console.log();
        var template = `
<style>
  body {
    background-color: #e0e0e0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    font-family: Calibri;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
    box-sizing: border-box;
    direction: rtl;
  }

  .label-card {
    width:10cm;
    height:7cm;
    background-color: #ffffff;
    border-radius: 6px;
    padding: 10px 10px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    direction: rtl;
    box-sizing: border-box;
  }

  .sender-section {
    border-bottom: 1px dashed #888;
    padding-bottom: 5px;
    margin-bottom: 5px;
  }

  .header-flex {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .sender-info {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }


  .sender-brand {
    display: flex;
    justify-content: space-between;
    margin-top:15px;
    width:100%;
  }

  .receiver-section {
    padding-top: 0px;
  }

  .info-row {
    display: flex;
    margin-bottom: 6px;
    font-size: 14px;
    align-items: baseline;
  }

  .info-row .label {
    font-weight: bold;
    color: #000;
    min-width: 70px;
  }

  .info-row .value {
    color: #000;
  }

  .info-row .value-ltr {
    color: #000;
    direction: ltr;
    text-align: left;
  }

  .icon-svg {
    width: 20px;
    height: 20px;
    fill: #222;
    display: inline-block;
    vertical-align: middle;
  }

  .icon-container {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 4px;
    flex-direction: row-reverse;
  }

  .insta-text {
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 0.5px;
    direction: ltr;
  }

  .logo-img {
    max-height: 50px;
    width: auto;
    max-width: 150px;
    object-fit: contain;
    margin-bottom: 5px;
  }

  @media print {
    body { background: white; padding: 0; }
    .label-card { box-shadow: none; border: 1px solid #ccc; border-radius: 0; }
  }
</style>

<div class="label-card">

  <div class="sender-section">
    <div class="header-flex">

      <div class="sender-info">
        
        <div style="font-size:13px; color:#000; margin-top:4px;">
          <b>آدرس فرستنده:</b><br />  اصفهان - ورودی خورزوق - خیابان حاج میر شمس الدین
        </div>
     
      </div>

      <div class="sender-brand">
        <div><h3>بازار ماهی سیمرغ</h3></div>
        <div>
          <div class="icon-container">

            <svg class="icon-svg" viewBox="0 0 24 24">
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
            </svg>
            <span style="font-weight:bold; font-size:16px; direction:ltr;">${settings.whatsapp || '۰۹۱۲...'}</span>
          </div>

          <div class="icon-container" style="margin-top:5px;">

            <svg class="icon-svg" viewBox="0 0 24 24">
              <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"/>
            </svg>
            <span class="insta-text">MAHI.SIMORGH</span>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="receiver-section">
    
    <div class="info-row">
      <span class="label">آدرس گیرنده:</span>
      <span class="value">${address || 'آدرس گیرنده...'}</span>
    </div>

    <div class="info-row">
      <span class="label">نام گیرنده:</span>
      <span class="value">${fullName || 'نام و نام خانوادگی'}</span>
    </div>

    <div class="info-row">
      <span class="label">تلفن گیرنده:</span>
      <span class="value-ltr">${tel || '۰۹۱۲...'}</span>
    </div>

  </div>

</div>
        `;

        return template;
      }
    },
    reset() {
      this.$refs.form.reset();

      this.formItems = {};
    },

    labelPrint() {
      this.isLoading = true;

      $("<iframe>", {
        name: "myiframe",
        class: "printFrame",
      })
        .appendTo("body")
        .contents()
        .find("body")
        .append(this.printTemplate());

      setTimeout(() => {
        this.isLoading = false;
        window.frames["myiframe"].focus();
        window.frames["myiframe"].print();
      }, 1000);
      setTimeout(() => {
        $(".printFrame").remove();
      }, 2000);
    },

    showFullSizeImage() {
      var url = this.formItems.receipt_file_url;
      window.open(url, "receipt image");
    },

    clearKendos(_refs) {
      for (let ref of _refs) {
        if (this.$refs[ref]) this.$refs[ref].emptyKendo();
      }
    },
    onCloseModal(e) {
      this.formItems = {};
      let dropDowns = ["statusDropDown"];
      this.clearKendos(dropDowns);
      this.reset();
    },
    paymentSuccessfully(e) {
      this.$emit("on-update", this.formItems);
    },
  },
};
</script>
